<template>
    <div>


        <section id="e404" class=" mt0 mb0 pb0">



            <div class="mt0 mb0 pb0">


                <div class="columns pt50 mt0 mb0 pb0">

                    <div class="column  is-7 mt0 mb0 pb0">
                        <img src="/images/layout/erro.png" alt="" style="height: 10rem;">
                        <h1>Oops... PÁGINA NÃO ENCONTRADA</h1>

                        <p>
                            Alguma coisa correu mal... <br>
                            Se este erro persistir contacte-nos.
                        </p>


                        <div>

                            <a class="button f-button is-info" @click="$router.go(-1)">
                                <i class="fa fa-angle-left" style="margin-right:1.5rem;"></i>
                                VOLTAR À PÁGINA ANTERIOR&nbsp;

                            </a>

                        </div>



                        <div>

                            <img src="/images/layout/LogoBranco.png" alt="" style="">


                        </div>




                    </div>

                    <div class="column is-5 is-hidden-touch mt0 mb0 pb0">

                      <!--  <div class="iphone">

                        </div>-->

                        <img src="/images/layout/ipad.png" alt="" style="height:80vh">
                    </div>

                </div>

            </div>



        </section>

    </div>

</template>

<script>
import { removeChatMixin } from "../plugins/removeChatMixin";

export default {
  mixins: [removeChatMixin]
};
</script>

<style scoped lang="scss">
#e404 {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#d80651+0,8f0f3f+100 */
  background: #d80651; /* Old browsers */
  background: -moz-linear-gradient(
    left,
    #d80651 0%,
    #8f0f3f 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    left,
    #d80651 0%,
    #8f0f3f 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to right,
    #d80651 0%,
    #8f0f3f 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d80651', endColorstr='#8f0f3f',GradientType=1 ); /* IE6-9 */

  min-height: 100vh;
  max-height: 100vh;
  min-width: 100vw;
  max-width: 100vw;

  padding: 3rem 8rem;
}

#e404 h1 {
  color: white;
  padding: 1rem 0 3rem;
  font-weight: 700;
  font-size: 2.25rem;
}

#e404 p {
  color: white;
  //padding: 3rem 0 6rem;
  font-weight: 400;
  font-size: 1.25rem;
}

.button {
  margin: 6rem 0 9rem;
  font-weight: 500;
  padding: 1.5rem 3rem;
  font-size: 1.2rem;
}

.iphone {
  position: relative;
  background-image: url("/static/images/layout/ipad.png");
  background-size: 100%, contain;
  background-position: top;
  height: 100%;
}

@media only screen and (max-width: 768px) {
  #e404 {
    padding: 2rem;
  }

  .button {
    margin: 3rem 0 4.5rem;

    padding: 1.5rem 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue